import { Button, Caption1, Card, CardHeader, Tag, Text } from "@fluentui/react-components";
import moment from "moment";
import { memo } from "react";
import { SearchHistory } from "../../store/LocalDbStore";
import { useSearchHistoryCardStyles } from "./styles";

export type SearchHistoryCardProps = {
  history: SearchHistory;
  onChangeSearch: (history: any) => void;
};

export const SearchHistoryCard = memo(({ history, onChangeSearch }: SearchHistoryCardProps) => {
  const styles = useSearchHistoryCardStyles();

  return (
    <Card appearance="outline" className={styles.historyCard}>
      <CardHeader
        header={
          <div className={styles.headerTagsContainer}>
            <Tag size="small" appearance="outline" className={styles.tagNavy}>
              <b>Type:</b> {history.searchTypeName}
            </Tag>
            <Tag size="small" appearance="outline" className={styles.tagNavy}>
              <b>Workspace:</b> {history.workspaceName}
            </Tag>
          </div>
        }
      ></CardHeader>
      <Text wrap={false} weight="regular" className={styles.searchText}>
        <b>Search Terms: </b>
        {history.searchText}
      </Text>

      <div className={styles.footerRow}>
        <Caption1 italic>{moment(history.timestamps).calendar()}</Caption1>

        <div className={styles.buttonGroup}>
          <Button
            appearance="subtle"
            className={styles.historyCardAction}
            onClick={() => onChangeSearch(history)}
            size="small"
          >
            Search Again
          </Button>
        </div>
      </div>
    </Card>
  );
});
